import InputsTextfield from '../textfield';

import {
  PLANNER_CLICK_PARTITION
} from 'apps/events';

class InputsNumberAndPartition extends InputsTextfield {
  onClickPartition(e) {
    let inputNumber:HTMLInputElement = this.querySelector('input[type="number"]') as HTMLInputElement
    let value = inputNumber.value;
    let detail = { value: value, task_id: this.parent.opts.task_id }
    let customEvent = new CustomEvent(PLANNER_CLICK_PARTITION, { detail: detail });
    document.dispatchEvent(customEvent);
  }
}
riot.mixin('inputs.complex.number-and-partition', InputsNumberAndPartition as riot.TagMixin);
